// extracted by mini-css-extract-plugin
export default {"headerContainer":"header_headerContainer__V6jNR","header_bg":"header_header_bg__F7F1h","menu":"header_menu__5J9BS"};